// removed by extract-text-webpack-plugin
module.exports = {"profile-photo":"profile-photo__2AROG","placeholder":"placeholder__2gRjl"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/UserImage/styles.scss
// module id = ./app/scripts/views/App/components/UserImage/styles.scss
// module chunks = 1